// extracted by mini-css-extract-plugin
export default {"restartButton":"RestartButton_restartButton__Pa40-"};